import { DateTime } from 'luxon'

export const downloadCSVData = (data: string, fileName?: string) => {
  const anchor = document.createElement('a')
  anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(data)
  anchor.target = '_blank'
  anchor.download = formatFileName('csv', fileName)
  anchor.click()
  anchor.remove()
}

export const downloadZipData = async (data: string, fileName: string) => {
  const byteCharacters = atob(data)
  const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i))
  const byteArray = new Uint8Array(byteNumbers)
  const blob = new Blob([byteArray], { type: 'application/zip' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = formatFileName('zip', fileName)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}

function formatFileName(extension: string, fileName?: string): string {
  const time = DateTime.now().toFormat('yyyy-MM-dd--HH-mm-ss')
  return `pbstck-${fileName || 'data'}-${time}.${extension}`
}
